const sentechBlue = "#004f9f";
const sentechDarkGrey = "#706f6f";
const sentechLightGrey = "#c6c6c6";

export { sentechBlue, sentechLightGrey, sentechDarkGrey };
